// Open PDFs in a new window

jQuery('a[href$=".pdf"]').each(function() {

    jQuery(this).bind("click",function(e){
        e.preventDefault();
        e.stopPropagation();
        window.open(this.href, '_blank');
    });

});